import { ICatalogSnapshot } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const catalogSnapshotApi = crudEndpointsFactory<ICatalogSnapshot>()('catalog-snapshots', 'CatalogSnapshots')
  .injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
      publishPreviewCatalogSnapshot: builder.mutation<any, { catalogSnapshotId: string }>({
        invalidatesTags: ['CatalogSnapshots'],
        query: (body) => ({
          url: `catalog-snapshots/${body.catalogSnapshotId}/preview`,
          method: 'POST'
        }),
      }),
      publishCatalogSnapshot: builder.mutation<any, { catalogSnapshotId: string, connector: string }>({
        invalidatesTags: ['CatalogSnapshots'],
        query: (body) => ({
          url: `catalog-snapshots/${body.catalogSnapshotId}/publish`,
          method: 'POST',
          body: {
            connector: body.connector
          },
        }),
      }),
    }),
  });
